import { JsonObject, JsonProperty } from 'json2typescript';
import { Entity } from './entity';

@JsonObject('CompanyGroup')
export class CompanyGroup extends Entity {
  @JsonProperty('name', String)
  public name?: string = undefined;
  @JsonProperty('description', String, true)
  public description?: string = undefined;
  @JsonProperty('createdDate', String, true)
  public createdDate?: string = undefined;
  @JsonProperty('modifiedDate', String, true)
  public modifiedDate?: string = undefined;
}
